import React from 'react';
import { Heart } from 'lucide-react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
interface DividerProps {
  className?: string;
}
export function Divider({
  className
}: DividerProps) {
  return <div className={twMerge('flex items-center justify-center w-full py-8 opacity-60', className)} data-id="element-81">
      <div className="h-px bg-brand-gold/40 flex-1 max-w-[100px]" data-id="element-82"></div>
      <Heart className="w-4 h-4 mx-4 text-brand-gold fill-brand-gold/20" strokeWidth={1.5} data-id="element-83" />
      <div className="h-px bg-brand-gold/40 flex-1 max-w-[100px]" data-id="element-84"></div>
    </div>;
}